// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createActionsHook,
	createHook,
	createStateHook,
	createStore,
} from '@atlassian/react-sweet-state';
import { actions } from '../controllers/actions/index.tsx';
import type { State } from './types.tsx';

import { QUICKSTART_UI_STATUS_NOT_LOADED } from './constants.tsx';

const initialState: State = {
	visibility: QUICKSTART_UI_STATUS_NOT_LOADED,
	permissions: [],
	isAvailable: false,
	openTaskId: null,
	spotlightStepId: null,
	mountedSpotlightIds: [],
	tasks: null,
	onEvent: null,
};

export const store = createStore<State, typeof actions>({
	name: 'jpd-onboarding-quickstart',
	initialState,
	actions,
});

export const useJpdOnboarding = createHook(store);

export const useActions = createActionsHook(store);

export const useTasks = createStateHook(store, {
	selector: (state) => state.tasks,
});

export const useVisibility = createStateHook(store, {
	selector: (state) => state.visibility,
});

export const useIsAvailable = createStateHook(store, {
	selector: (state) => state.isAvailable,
});

export const useOpenTaskId = createStateHook(store, {
	selector: (state) => state.openTaskId,
});

export const useSpotlightStepId = createHook(store, {
	selector: (state) => state.spotlightStepId,
});

export const useMountedSpotlightIds = createStateHook(store, {
	selector: (state) => state.mountedSpotlightIds,
});

export const useCanCreateAndEditIdeas = createStateHook(store, {
	selector: (state) =>
		['CREATE_ISSUES', 'EDIT_ISSUES'].every((key) =>
			state.permissions.some(
				(permission) => permission.key === key && permission.havePermission === true,
			),
		),
});

export const useCanManageViews = createStateHook(store, {
	selector: (state) =>
		state.permissions.some(
			(permission) =>
				permission.key === 'MANAGE_DISCOVERY_VIEWS' && permission.havePermission === true,
		),
});

export const useCanManageDelivery = createStateHook(store, {
	selector: (state) =>
		state.permissions.some(
			(permission) =>
				permission.key === 'MANAGE_DISCOVERY_DELIVERY' && permission.havePermission === true,
		),
});

export const useCanShareViews = createStateHook(store, {
	selector: (state) =>
		state.permissions.some(
			(permission) =>
				permission.key === 'SHARE_DISCOVERY_VIEWS' && permission.havePermission === true,
		),
});
